import React from 'react';
import Facebook from '../icons/Facebook';
import LinkedIn from '../icons/LinkedIn';
import Twitter from '../icons/Twitter';
import BackButton from '../molecules/BackButton';

interface ResourceShareSheetProps {
  title: string;
  backButtonUrl: string;
  shareUrl: string;
}

const ResourceShareSheet: React.FC<ResourceShareSheetProps> = ({
  title,
  shareUrl,
  backButtonUrl,
}) => {
  const handleShare = (
    targetUrl: string,
    params: Record<string, string | number | boolean>,
  ) => {
    if (!window) {
      return;
    }

    const popWidth = 600;
    const popHeight = 480;
    const left = window.innerWidth / 2 - popWidth / 2 + window.screenX;
    const top = window.innerHeight / 2 - popHeight / 2 + window.screenY;
    const popParams = `scrollbars=no, width=${popWidth}, height=${popHeight}, top=${top}, left=${left}`;

    const paramsString = Object.entries(params)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&');

    const popupWindow = window.open(
      `${targetUrl}?${paramsString}`,
      '',
      popParams,
    );
    if (window.focus) {
      popupWindow.focus();
    }
  };

  return (
    <section className="my-10 border-t lg:my-20 border-slate-100">
      <div className="container flex items-center justify-between py-10">
        <BackButton url={backButtonUrl} label="Go back" />

        <div className="flex items-center px-4 py-2 rounded bg-slate-100">
          <div className="hidden mr-8 text-xs font-bold tracking-widest uppercase text-slate-400 sm:block">
            Share
          </div>

          <div className="flex items-center space-x-8">
            <button
              className="transition text-slate-400 hover:text-slate-900 u-ring"
              onClick={() =>
                handleShare('https://www.facebook.com/sharer/sharer.php', {
                  u: shareUrl,
                })
              }
              aria-label="Share on Facebook"
            >
              <Facebook className="w-auto h-5" />
            </button>
            <button
              className="transition text-slate-400 hover:text-slate-900 u-ring"
              onClick={() =>
                handleShare('https://twitter.com/intent/tweet/', {
                  text: title,
                  url: shareUrl,
                  mini: true,
                  via: 'StackScout',
                })
              }
              aria-label="Share on Twitter"
            >
              <Twitter className="w-auto h-5" />
            </button>
            <button
              className="transition text-slate-400 hover:text-slate-900 u-ring"
              onClick={() =>
                handleShare('https://www.linkedin.com/shareArticle', {
                  url: shareUrl,
                  mini: true,
                })
              }
              aria-label="Share on LinkedIn"
            >
              <LinkedIn className="w-auto h-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResourceShareSheet;
